// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"13":"9dcd01cf08df66c5b8d2","96":"9056fc644a18d8a760d4","914":"4f87c2a6dd99cd7bc3b6"}[chunkId] + ".js";
};